import { display } from "redux-react/reducers/snackBarReducer";
import { api } from "./api";

const actions = {
	/**
	 * Allow to insert a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {object} data the data to insert
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	insertResource: (resource, data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/resource/${resource}`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Allow to get a list of resources from the backend
	 * @param {string} resource the resource code like "message"
	 * @param {object} params the query parameters to filter resources
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	getResources: (resource, params, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/resource/${resource}`,
					data: params,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Allow to get a resource from the backend
	 * @param {string} resource the resource code like "message"
	 * @param {string} resourceID the id of the resource
	 * Allow to get a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {object} resourceID the data to insert
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	getResource: (resource, resourceID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/resource/${resource}/${resourceID}`,
					onSuccess,
					onFailure
				})
			);
		};
	},

	/**
	 * Allow to get a list of resource on the backend
	 * @param {string} resourceCode the resource code like "message"
	 * @param {object} filters the filters to apply to the request (mongo like)
	 * @param {object} queryOptions the options for the query like pagination and sort
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	getResources: (resourceCode, queryOptions = {}, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/resource/${resourceCode}`,
					data: {
						...queryOptions
					},
					onSuccess,
					onFailure
				})
			);
		};
	},

	/**
	 * Allow to get a list of resource on the backend
	 * @param {string} resourceCode the resource code like "message"
	 * @param {object} filters the filters to apply to the request (mongo like)
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	getResourcesCount: (resourceCode, filters = {}, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/resource/list/count/${resourceCode}`,
					data: {
						filterQueryObject: filters
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Allow to update a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {string} resourceID the id of the resource
	 * @param {object} resourceUpdate the updates to bring to the resource
	 * @param {function} onSuccess the function to call on success
	 */
	updateResource: (resource, resourceID, resourceUpdate, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/resource/${resource}/${resourceID}`,
					data: resourceUpdate,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error ?? "none"
							})
						);
					}
				})
			);
		};
	},
	/**
	 * Allow to delete a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {string} resourceID the id of the resource
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	deleteResource: (resource, resourceID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/api/v1/resource/${resource}/${resourceID}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Allow to update a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {object} resourceUpdate the updates to bring to the resource
	 * @param {function} onSuccess the function to call on success
	 */
	updateResourceConfiguration: (resource, resourceUpdate, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/resourceConfig/${resource}`,
					data: {
						update: resourceUpdate
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Perform an action on a resource
	 * @param {object} data the data to send to the backend
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	performAction: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/resource/action/perform`,
					data,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						onFailure(err.response?.data?.error ?? err);
					}
				})
			);
		};
	},
	/**
	 * Insert an event for a resource
	 * @param {string} resource - the resource code like "message"
	 * @param {string} resourceID - the id of the resource
	 * @param {object} data the data to send to the backend
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 * @returns {function} a redux thunk function
	 */
	insertResourceEvent: (resource, resourceID, data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/resource/${resource}/${resourceID}/event`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
